<div class="form-group-block">
    <div class="form-group">
        <label>&nbsp;</label>
        <input type="text" [(ngModel)]="secretKey" class="form-control" placeholder="Enter secret key" />
    </div>
</div>
